import { render, staticRenderFns } from "./DetalhesConvenio.vue?vue&type=template&id=433dc816&scoped=true"
import script from "./DetalhesConvenio.vue?vue&type=script&lang=js"
export * from "./DetalhesConvenio.vue?vue&type=script&lang=js"
import style0 from "./DetalhesConvenio.vue?vue&type=style&index=0&id=433dc816&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "433dc816",
  null
  
)

export default component.exports